import { GetWBComponentByTypename } from "./Data/WBData";
import LayoutNode, { getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import GenerateCSSTokensFromLayoutNodes from "vagaro-website-rendering/src/components/Utilities/GenerateCSSTokensFromLayoutNodes";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import Reactserver from "react-dom/server";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

import { SiteData } from "./Data/SiteData";
import { googleFonts } from "./StyleInputs/FontField";
import { compileCustomCSS } from "./RenderCustomCSS";
import DOMPurify from "dompurify";
import { ToggleNames } from "vagaro-website-rendering/src/components/Binding/BindAllToggles";
import generateGlobalStyleFromSiteData from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";


export function PurifyWithAtts(str:string){

    if(str.startsWith("<style")){ // bug with dom purify that removes style tags not inside another dom
        str = "<div>"+str+"</div>";

    }

    const replaceList:{key:string,val:string}[] = [];

    let keyIndex = 0;
    DOMPurify.addHook('uponSanitizeAttribute', (node:any, data) => {
        if (node.tagName === 'IFRAME' && data.attrName.toLowerCase() === 'srcdoc') {
            // Sanitize srcDoc content separately

            keyIndex++;
            let val = data.attrValue;
            let key = `@!@${keyIndex.toString()}@!@`;
            replaceList.push({key:key,val:val});
            data.attrValue = key;

            data.forceKeepAttr = true; // Force keeping the attribute
        }
    });

    let cleanHtml = DOMPurify.sanitize(str, {
        ADD_TAGS: ['iframe','link'], // we need to allow sandbox iframes and google font links..
        ADD_ATTR: ['target','sandbox','src','srcDoc','layout','data-link-key','encbid',"filters","component-attributes","componenttype","data-expires-at","data-id","multilocal","srcDoc","vanimation","wbcomponent","data-nosnippet","isShowLogo","formbg","formfc","displayform",ToggleNames.ToggleIndexAttribute], // include all special attributes used for binding
        FORCE_BODY: true
    });

    //each srcdoc in an iframe is sandboxed so we are save to add any content
    replaceList.forEach((item)=>{

        cleanHtml = cleanHtml.replace(item.key,item.val);
    });

    return cleanHtml;
}

export function GetAllSpecialCSSFromLayoutNodes(rootNode:LayoutNode,isLivePublish:boolean = false){

    let pendingList = [rootNode];

    let returnString = "";

    while(pendingList.length>0){

        let node = pendingList.pop();
        if(!node)
            continue;

        for(let i = 0;i<node.children.length;i++){

                pendingList.push(node.children[i]);
        }

        let str = GetWBComponentByTypename(node.typename).GetComponentGlobalCSS(node,false,isLivePublish);

        if(str&&str.length>0)
            returnString += str+"\n";
    }

    return returnString;

}


export function GetFontIncludes({root,siteData}:{root:LayoutNode,siteData?:SiteData}){

    let pendingList = [root];

    let fontIncludes: string[] = [];
    if(siteData){
        if(siteData.siteStyling.fontPrimary!=""&&googleFonts.indexOf(siteData.siteStyling.fontPrimary)>=0)
            fontIncludes.push(siteData.siteStyling.fontPrimary);

        if(siteData.siteStyling.fontSecondary!=""&&googleFonts.indexOf(siteData.siteStyling.fontSecondary)>=0)
            fontIncludes.push(siteData.siteStyling.fontSecondary);


        let style = siteData.siteStyling;
        let attributeList = [
            style.heading1,
            style.heading2,
            style.heading3,
            style.heading4,
            style.paragraph1,
            style.paragraph2,
            style.paragraph3,
            style.buttonPrimary,
            style.buttonSecondary,
            style.buttonTertiary,
        ];

        attributeList.forEach(element => {
            let font = getNodeStyleAttributeValue(element,0,"fontFamily","");
            if(font!=""&&fontIncludes.indexOf(font)<0 && googleFonts.indexOf(font)>=0)
                fontIncludes.push(font);
        });
    }



    while(pendingList.length>0){

        let node = pendingList.pop();
        if(!node)
            continue;

        for(let i = 0;i<node.children.length;i++){

            pendingList.push(node.children[i]);
        }

        for(let f = 0;f<3;f++){

            let font = getNodeStyleAttributeValue(node,f,"fontFamily","");

            if(font!=""&&fontIncludes.indexOf(font)<0 && googleFonts.indexOf(font)>=0){
                fontIncludes.push(font);
            }
        }
    }

    return <>
        {fontIncludes.map((font,i:number)=>{
            let formatted = font.replaceAll(" ","+");
            return <link key = {font+i.toString()} href={`https://fonts.googleapis.com/css2?family=${formatted}`} rel="stylesheet" />;
        })



    }

    </>;
}

export function GetStylingForSingleNode(node:LayoutNode,siteData:SiteData,tokenPrefix:string = "",isLivePublish:boolean = false){

   return  GenerateCSSTokensFromLayoutNodes(node,tokenPrefix)+"\n"+GetAllSpecialCSSFromLayoutNodes(node,isLivePublish)+"\n"+compileCustomCSS(siteData,node,false);
}

export function GeneratePublishForSingleNode(node:LayoutNode,siteData:SiteData,includeCSS:boolean = false,tokenPrefix:string = "",isLivePublish:boolean = false,includeFonts:boolean =false){


    let cssString = "";

    if(includeCSS){
        cssString = GetStylingForSingleNode(node,siteData,tokenPrefix,isLivePublish);

    }
    else{
        GetStylingForSingleNode(node,siteData,tokenPrefix,isLivePublish);//we need to generate the tokens regardless if we save the style
    }

    let returnString = Reactserver.renderToString(
            <>
            { includeCSS&&<style> {cssString} </style>

            }
            <RenderForPublish node={node} siteData={siteData.userContext}/>
            {includeFonts&& <GetFontIncludes root={node} siteData={siteData }/>}
            </>
    );

    returnString = returnString.replace(/[\t ]+|(\n\s*)+/g, ' ');




    return PurifyWithAtts(returnString);

}

const sectionList = [wBComponentTypeNames.section,wBComponentTypeNames.blogHeading];// treat this components as valid sections (ie blog heading is a section)

export function GeneratePublishHTMLString(root:LayoutNode,siteData:SiteData,includeHeaderAndFooter = true,isLivePublish:boolean = false){

    let cssTokens = "";




    if(!includeHeaderAndFooter){

        let newNode = {...root}; //clone the root node
        newNode.children = newNode.children.filter((child)=>{ return sectionList.includes(child.typename)});
        root = newNode;

        cssTokens = GenerateCSSTokensFromLayoutNodes(root,"",isLivePublish);
    }


    let returnString = Reactserver.renderToString(
        <div id="v-site render">
            <style dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(

                cssTokens + "\n" +
                GetAllSpecialCSSFromLayoutNodes(root,isLivePublish) +
                compileCustomCSS(siteData,root,false)
            )}}>
            </style>
            <GetFontIncludes root={root} siteData={siteData}/>
            <RenderForPublish node={root} siteData={siteData.userContext} isForLive={isLivePublish}/>
        </div>
    );

    returnString = returnString.replace(/[\t ]+|(\n\s*)+/g, ' ');

    return PurifyWithAtts(returnString);





}


function RenderForPublish({node,siteData,parent,isForLive}:{node:LayoutNode,siteData:UserContext,parent?:LayoutNode|undefined|null,isForLive?:boolean}){

    const component = GetWBComponentByTypename(node.typename);
    const Component = component.RenderLayout;

    //make sure parents are set correctly
    if(parent){
        node.parent = parent;
    }

    return (

            <Component key={node.id } screenSize = {ScreenSize.Desktop} component={node} isLivePublish={isForLive} userContext={siteData} isEditor={false} >
                {//Render All Nested Child Components
                node?.children &&
                    node.children.map((child, i) => {
                        return <RenderForPublish key = {child.id} node={child}  siteData={siteData} parent={node} isForLive={isForLive}/>
                    }
                )}
            </Component>

    );

}